import React, { useEffect } from "react";
import styled from "styled-components";
//
import Aos from "aos";
import "aos/dist/aos.css";
import { motion } from "framer-motion";

import { mobile, mobileM, tablet } from "../../responsive";
const imgSavoirFaire =
  "https://images.pexels.com/photos/7120210/pexels-photo-7120210.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
//
//
const SavoirFaireContainer = styled.div`
  width: 100vw;
  min-height: 60vh;

  display: flex;
  align-items: center;
  flex-direction: row;
  background-color: rgb(243, 243, 243);

  //
  ${mobile({ flexDirection: "column" })}
  ${mobileM({ flexDirection: "column" })}
  ${tablet({ flexDirection: "column" })}
`;
//

// ** LEFT **
//
const Left = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
`;

//
//

const ImgContainer = styled.div``;
const ImgBox = styled.div`
  margin: 0;
  padding: 0;
  width: 100%;
  overflow: hidden;

  //
  img {
    width: 100%;
    min-height: auto;
    object-fit: cover;

    //
    ${mobile({ borderRadius: "0" })}
    ${mobileM({ borderRadius: "0" })}
  ${tablet({ borderRadius: "0" })}

   //
  }
`;
//
//
const Right = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
`;
//
const Container = styled.div`
  padding: 50px;
  ${mobile({
    padding: "70px 30px",
  })}
  ${mobileM({
    padding: "70px 40px",
  })}
   ${tablet({
    padding: "70px 50px",
  })}
  //
  //
  h1,
  h2,
  h3 {
    padding: 0 0 0 0;
    color: #0f0f0ff6;
    font-size: calc(6px + 1vmin);
    text-transform: uppercase;
    font-family: "Poppins-light";
    letter-spacing: 1px;
  }
  h2 {
    margin: 0 50% 0 0;
    padding: 10px 0 30px 0;
    color: #0f0f0f;
    font-size: calc(10px + 4vmin);
    text-transform: Capitalize;
    line-height: 42px;
    ${mobile({
      padding: "25px 0 30px 0",
      lineHeight: "35px",
      margin: "0 20% 0 0",
    })}
    ${mobileM({
      padding: "25px 0 30px 0",
      lineHeight: "35px",
      margin: "0 20% 0 0",
    })}
        ${tablet({
      padding: "25px 0 30px 0",
      lineHeight: "35px",
      margin: "0 20% 0 0",
    })}
  }
  p {
    color: #0f0f0fcf;
    margin: 0 0 40px 0;
    font-size: calc(7px + 1vmin);
    ${mobile({
      margin: "0 0 50px 0",
      textAlign: "left",
      fontSize: "calc(9px + 1.4vmin)",
      lineHeight: "25px",
    })}
    ${mobileM({
      margin: "0 0 50px 0",
      textAlign: "left",
      fontSize: "calc(9px + 1.4vmin)",
      lineHeight: "calc(19px + 1.4vmin)",
    })}
      ${tablet({
      margin: "0 0 50px 0",
      textAlign: "left",
      fontSize: "calc(9px + 1.4vmin)",
      lineHeight: "calc(19px + 1.4vmin)",
    })}
  }

  button {
    padding: 13px 35px;
    margin: 0;
    font-weight: 600;
    font-size: calc(7px + 1vmin);
    border-radius: 100px 100px 100px 100px;
    background-color: transparent;
    border: 1.5px solid #0f0f0f;
    color: #0f0f0f;
    text-transform: uppercase;

    transition: 0.3s ease-in-out;
    &:hover {
      padding: 13px 35px;
      margin: 0;
      background-color: rgb(10, 10, 10);
      border: 1.5px solid rgb(24, 24, 24);
      font-weight: 100;
      color: #eeeeee;
    }
  }
`;

//
//

const About = () => {
  //
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);
  //
  //
  //
  return (
    <>
      <SavoirFaireContainer>
        <Left>
          <ImgContainer>
            <ImgBox>
              <motion.img
                data-aos="fade-right"
                whileHover={{ scale: 1.1 }}
                onHoverStart={(eImg) => {}}
                onHoverEnd={(eImg) => {}}
                src={imgSavoirFaire}
              />
            </ImgBox>
          </ImgContainer>
        </Left>
        <Right>
          <Container>
            {" "}
            <h1>The Project</h1>
            <h2>Camaie Store</h2>
            <p>
              This e-commerce store is a visual representation of my practice
              with React, SCSS, Styled Components, AOS, Framer Motion and HTML.
              I did implement other factors, such as Blender and THREEjs.
              <br />
              <br />
              As I needed to learn these skills from the beginning, it made the
              process a little more complicated. It took me close to 7 months to
              learn the bases on Blender, and come up with my final product -
              the 3D render of the Lounge Chair seen on the Homepage. After that
              I continued with THREEjs, which I learned for the purpose of
              adding my 3D models on websites, and to bring me closer to my
              final goal.
              <br />
              <br />
              The main objective for this project was actually to bring me
              closer to configuring 3D scenes, and to give my users the pleasure
              of experiencing any available product in an immersive way. I'm
              aware that I'm nowhere near the level of skills needed to be a
              professional at this, but I feel like this project is a pretty
              good start.
              <br />
              <br />
              {/* “ Trademarks mentioned herein are the property of their
              respective owners. Any names, places or events bearing any
              resemblance to actual persons, entities or events are purely
              coincidental. */}
            </p>
            <button>Read More</button>
          </Container>
        </Right>
      </SavoirFaireContainer>
    </>
  );
};

export default About;
